
import { useStore } from '@/composables/use-store'
import { computed, defineComponent, ref } from 'vue'
import SaveChangesBar from '@/components/SaveChangesBar.vue'

export default defineComponent({
  name: 'CampaignFormSettings',
  components: {
    SaveChangesBar
  },
  setup () {
    const store = useStore()

    const allCountries: Record<string, string> = store.getters['i18n/englishCountries'] // list of all countries
    const initialSelection = computed(() => store.getters['campaigns/currentParticipatingCountries']) // list of selected country codes
    const selectedCountries = ref<string[]>(initialSelection.value.slice())
    const allCountriesItems = computed(() => {
      return Object.entries(allCountries).map(([key, value]) => ({
        text: value,
        value: key
      }))
    })

    const unsavedChanges = computed(() => {
      return selectedCountries.value.length !== initialSelection.value.length ||
        selectedCountries.value.some((country) => !initialSelection.value.includes(country))
    })

    const saveChanges = () => store.dispatch('campaigns/EDIT_CURRENT', { participating_countries: selectedCountries.value })

    return {
      initialSelection,
      selectedCountries,
      allCountries,
      allCountriesItems,
      unsavedChanges,
      saveChanges

    }
  }
})
